<template>
  <div class="container" :data-corp-id="corpId">
    <div class="product_item">
        <p class="title">奖品信息</p>
        <div class="item_wrap">
            <div class="img_box">
             <img src="../../assets/img/product.jpg" alt="">
             </div>
            <dl>
              <dt>水星时尚四件套</dt>
              <dd>福利</dd>
              <dd>数量：1</dd>
            </dl>
          </div>
      </div>
       <div class="address_wrap">
         <p class="title">收货信息</p>
         <ul>
           <li><label>收货人</label><div class="text-item"><input type="text" placeholder="姓名" v-model="addname" v-verify="addname"></div></li>
           <li><label>联系电话</label><div class="text-item"><input type="tel" placeholder="手机" maxlength="11" v-model="addphone" v-verify="addphone"></div></li>
           <li><label>选择地区</label>
            <x-address @on-hide="logHide" @on-show="logShow" :title="title" v-model="addressValue" :list="addressData" placeholder="地区信息" v-verify='addressValue'></x-address>
           <li class="address_textarea"><label>详细地址</label><div class="tarea"><textarea placeholder="街道门牌信息" v-model="addAddress" v-verify="addAddress"></textarea></div></li>
         </ul>
         <div class="btn-wrap">
           <a href="javascript:;" class="btn btn-default" @click="getPrizeFun">确认领取</a>
         </div>
      </div>
     <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
      <home :ishome=0></home>
  </div>
</template>
<script>
import  Group  from 'vux/src/components/group/index.vue'
import  XAddress  from 'vux/src/components/x-address/index.vue'
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
import  PopupHeader  from 'vux/src/components/popup-header/index.vue'
import  Value2nameFilter  from 'vux/src/filters/value2name.js'
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	addressData:window.areaData,
      addressValue:[],
      title:'',
      loading:true,
      tipDialog:false,
      addname:'',
      addphone:'',
      addAddress:'',
      tipText:'',
      addBtnClick:true,
    }
  },
  components:{
    Group,
    XAddress,
    XDialog,
    home
  },
  verify: {
        addname:"required",
        addphone: ["required","phone"],
        addAddress:"required",
        addressValue:"required"
    },
  computed:{   	 	 
  	 ...mapGetters({
      getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },
  },
  watch:{

  },
  created(){

  },
  methods:{
      showMsg(txt){
      this.tipText=txt;
      this.tipDialog=true;
    },
    logHide (str) {

    },
    logShow (str) {
    },
    getPrizeFun(){
       if(!this.$verify.check()){
          console.log(this.$verify.$errors)
          if(this.$verify.$errors.addphone.length>0&&this.$verify.$errors.addname.length>0&&this.$verify.$errors.addressValue.length>0&&this.$verify.$errors.addAddress.length>0){
            this.showMsg('地址信息没填写')
            return;
          }
          if(this.$verify.$errors.addname.length>0){
            this.showMsg('请填写姓名')
            return;
          }
          if(this.$verify.$errors.addphone.length>0){
            if(this.$verify.$errors.addphone[0]=='手机号码格式不正确'){
              this.showMsg('手机号码格式不正确')
            }else{
              this.showMsg('请填写联系电话')
            }
            return;
          }
          if(this.$verify.$errors.addressValue.length>0){
            this.showMsg('请选择地区')
            return;
          }
          if(this.$verify.$errors.addAddress.length>0){
            this.showMsg('请填写详细地址')
            return;
          }

       }else{
          if(this.addBtnClick){
            let adds=this.getName.split(' ');
            let params={
              address:this.addAddress,
              consignee:this.addname,
              mobile:this.addphone,
              provinceId:this.addressValue[0],
              province:adds[0],
              cityId:this.addressValue[1],
              city:adds[1],
              districtId:this.addressValue[2],
              district:adds[2],
            }
            // console.log("addressparams",params)
            // this.$store.dispatch('doAddAddress',params) 改成领取奖品的接口
            this.addBtnClick=false
         }
          

       }

    }
  },
  mounted(){}
}
</script>